export const CROSS_SECTION_RECORDING_OVERLAY_REDRAW_EVENT = "cross-section-recording-overlay-redraw";
export const CROSS_SECTION_RECORDING_PREPARE_SNAPSHOT_EVENT = "cross-section-recording-prepare-snapshot";
